const ROUTES = {
  HOME: "/",
  LOGIN: "/login",
  FORGETPASSWORD: "/forget-password",
  MUBST: "/Credit-Control/Bank-Statement-Transactions",
  MUUF: "/Credit-Control/Upload-files",
  MUSU: "/Credit-Control/Statement-Upload",
  MUABT: "/Credit-Control/Allocate-Bank-Transactions",
  MUCASHTRACKER: "/Credit-Control/Cash-tracker",
  WLAI: "/Credit-Control/Work-List-Actions",
  MUBR: "/Credit-Control/Bank-Reconciliation",
  BTAR: "/Credit-Control/Agedebt-Reports",
  BTARD: "/Credit-Control/Agedebt-Reports/Details",
  CCC: "/Credit-Control/chaser/",
  AUM: "/Administration/User-Maintenance",
  BTAM: "/Administration/Accounting-Month",
  ALU: "/Administration/Lock/Unlock",
  AETM: "/Administration/Entity-Table",
  AUMAU: "/Administration/User-Maintenance/Add-User",
  AUMEU: "/Administration/User-Maintenance/Edit-User",
  AUMVU: "/Administration/User-Maintenance/View-User",
  LOBETM: "/Administration/LOB-Table",
  SCMTM: "/Administration/SCM-Table",
  BATM: "/Administration/Binding-Agreement",
  CTTM: "/Administration/CorrectionType-Table",
  ASTM: "/Administration/AllocationStatus-Table",
  BTM: "/Administration/Broker-Table",
  CTM: "/Administration/Corrective-Table",
  PTM: "/Administration/Policy-Table",
  ADA: "/Administration/Agedebt-Action",
  ADC: "/Administration/Agedebt-Category",
  CYTM: "/Administration/Currency-Table",
  BETM: "/Administration/BankExchange-Table",
  PMTM: "/Administration/Bank-Information-Table",

  CASHTRACKER: "/Reports/Cash-Tracker",
  SUD: "/Reports/Summary-USD-Dashboard",
  MER: "/Reports/Month-End-Report",
  OVRRECON: "/Reports/Overall-Reconciliation",
  COMMISSION: '/Reports/Commission',
  ABAS: "/Reports/Amounts-By-Allocation-Status",
  ABASAB: "/Reports/Amounts-By-Allocation-Status-Aging-Bucket",
  CTABD: "/Reports/Receivable-By-Entity",
  ABAB: "/Reports/Amounts-By-Aging-Bucket",
  ABL: "/Reports/Amounts-By-LOB",
  RWF: "/Reports/Write-off",
  RD: "/Reports/Refund-Report",
  ABCT: "/Reports/Amounts-By-Correction-Type",
  CT: "/Reports/Corrective-Transfers",
  CAR: "/Reports/Cross-Allocation-Report",
  CFI: "/Reports/CFI",

  CMA: "/Reports/Current-Month-Allocation-Non-SCM",
  MUCT: "/Reports/Correction-Types",

  PremiumBDX: "/BDX/PremiumBDX",
  Dashboard: "/Dashboard",
  TreasuryList:"/Treasury/Treasury",
  CoversheetList:"/Treasury/Coversheet",
  PayoutSummary:"/BDX/PayoutSummary",
  ExceptionReport:"/BDX/ExceptionReport",

  SLA:"/Administration/SLA-Table",
  ParticipatingInsurer:"/Administration/Participating-Insurer-Table",
  Escalation:"/Administration/Escalation-Table",
  AdministrationWorkflow: "/Administration/Workflow-Table",
  TxnCategory:"/Administration/TxnCategory-Table",
  TxnStatus:"/Administration/TxnStatus-Table",
  FileManagement:"/Administration/File-Management",

  AgedDebtDue: "/Credit-Control/Aged-Debt-Due",
  ChaserIndicator: "/Administration/Chaser-Indicator",
  APH: "/Credit-Control/Assign-Policy-Handler",
};

export default ROUTES;
